import { Button, buttonVariants } from '@src/design-system/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@src/design-system/dropdown-menu';
import { cn } from '@src/design-system/helpers';
import { Text } from '@src/design-system/text';
import { Edit } from 'iconsax-react';
import { EllipsisVerticalIcon, LoaderCircle } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { createRoute } from '@src/core/router/paths';
import BankInfoCollapse from './bank-info-collapse';
import { useDeleteBankAccount } from '../../services/delete-bank-account';
import memberApi from '@shared/services/member-api';

const UserBankInfo = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const { data: userData } = memberApi.useFetchOne({ id: userId });
  const { mutateAsync, isPending } = useDeleteBankAccount();

  return (
    <>
      <div className='flex justify-between items-center'>
        <Text className='text-gray-800 font-medium flex items-center gap-2'>
          Bank Info{' '}
          {isPending && (
            <LoaderCircle
              className='animate-spin'
              size={20}
            />
          )}
        </Text>
        <div className='flex items-center gap-2'>
          <Button
            size='sm'
            variant='primaryOutline'
            className='border-primary-200'
            onClick={() => navigate(createRoute(`/users/${userId}/bank-edit`))}
          >
            <Edit />
            {userData?.bank_account ? 'Edit' : 'Add'}
          </Button>
          <DropdownMenu>
            <DropdownMenuTrigger
              className={cn(
                buttonVariants({ size: 'iconSm', variant: 'primaryOutline' }),
                'border-primary-200'
              )}
            >
              <EllipsisVerticalIcon />
            </DropdownMenuTrigger>

            <DropdownMenuContent align='center'>
              <DropdownMenuItem
                disabled={!userData?.bank_account}
                className='text-red-600'
                onClick={() =>
                  mutateAsync({
                    userId: +userId!,
                    id: userData?.bank_account?.id || 0,
                  })
                }
              >
                Delete Bank Info
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
      <BankInfoCollapse bank_account={userData?.bank_account || null} />
    </>
  );
};

export default UserBankInfo;
